import { Alert, styled } from '@mui/material'

export const AlertContent = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1)};
`

export const StyledAlert = styled(Alert)`
  width: 100%;
  box-sizing: border-box;

  & .MuiAlert-message {
    width: 100%;
  }
`
